"use client";
import { Box } from "@chakra-ui/react";
import SharedIntelPricing from "@/views/pricing/components/tables/cloudVm/sharedIntel";

const PricingComp = () => {
  return (
    <Box id="pricing">
      <SharedIntelPricing />
    </Box>
  );
};

export default PricingComp;
